/** `1:04:07` -- a live timer, where the seconds moving is the point. */
export function formatClock(totalSeconds: number): string {
  const seconds = Math.max(0, Math.floor(totalSeconds));
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const rest = seconds % 60;
  const pad = (value: number) => String(value).padStart(2, '0');
  return hours > 0 ? `${hours}:${pad(minutes)}:${pad(rest)}` : `${minutes}:${pad(rest)}`;
}

/** `2h 15m` -- a total, where the seconds are noise. */
export function formatDuration(totalSeconds: number): string {
  const seconds = Math.max(0, Math.floor(totalSeconds));
  if (seconds < 60) return `${seconds}s`;

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.round((seconds % 3600) / 60);
  if (hours === 0) return `${minutes}m`;
  return minutes === 0 ? `${hours}h` : `${hours}h ${minutes}m`;
}

/**
 * Parse what someone types into the manual-entry box: `90m`, `1h30`, `1h 30m`,
 * `1:30`, `1.5h`, or a bare number read as minutes. Returns seconds, or null
 * when it cannot be read -- the caller shows a field error rather than guessing.
 */
export function parseDuration(input: string): number | null {
  const value = input.trim().toLowerCase();
  if (!value) return null;

  const clock = /^(\d+):([0-5]?\d)$/.exec(value);
  if (clock) return Number(clock[1]) * 3600 + Number(clock[2]) * 60;

  const parts = /^(?:(\d+(?:\.\d+)?)\s*h)?\s*(?:(\d+(?:\.\d+)?)\s*m?)?$/.exec(value);
  if (!parts || (parts[1] === undefined && parts[2] === undefined)) return null;

  const hours = parts[1] === undefined ? 0 : Number(parts[1]);
  const minutes = parts[2] === undefined ? 0 : Number(parts[2]);
  const seconds = Math.round(hours * 3600 + minutes * 60);

  return seconds > 0 ? seconds : null;
}
